import React from 'react';
import { useState, useEffect } from 'react';
import {

  Typography,
  IconButton,
  Box,
} from '@mui/material';
import { theme } from '../../theme';
import '@fortawesome/fontawesome-free/css/all.min.css';
import CustomBreadcrumbs from './BreadCrumbs';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useParams, useNavigate } from 'react-router-dom';
import AvatarImage from './AvatarImage';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ProfileNavBarPopup from '../Pages/Profile/ProfileNavBarPopUp'
import ProfileEditPanel from '../Pages/Profile/ProfileEditPanel';
import { useGlobalContext, UserDataType } from '../../Context/GlobalContext';
import ApiBaseUrl from '../../AppConfig/AppConfig.json'
import { apiUrl } from '../../Constant/apiConstant';


const TopNav: React.FC = () => {
  const { tenant } = useParams<{ tenant: string }>();
  const { userData, setUserData } = useGlobalContext();
  const navigate = useNavigate()
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [isProfileEditVisible, setProfileEditVisible] = useState(false);
  const [updatedImage, setUpdatedImage] = useState<string | null>(null)
  const token = localStorage.getItem("access_token");
  const baseURL = window.location.origin.endsWith('/')
    ? window.location.origin
    : `${window.location.origin}/`;

  const handlePopupClose = () => {
    setPopupOpen(false);
    setProfileEditVisible(false);
  };

  const handleTogglePopup = () => {
    setPopupOpen((prev) => !prev);
  };

  const handleProfileEditToggle = () => {
    setProfileEditVisible((prev) => !prev);
    setPopupOpen(false);
  };

  const updateUserData = (newData: UserDataType) => {
    setUserData(newData);
  };


  const handleLogout = () => {
    localStorage.removeItem('access_token')
    navigate(`/${tenant}/SignIn`)
  }

  const handleHelpClick = async () => {
  const API_base_url = ApiBaseUrl.apiBaseUrl;

  try {
    const newWindow = window.open('', '_blank');

    const response = await fetch(`${API_base_url}${apiUrl.ACM_GET_HELP_DOC}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token || ""}`,
        'X-Tenant': tenant || "",
        'X-App': baseURL || ""
      }
    });

    if (!response.ok) {
      console.error('Failed to fetch help doc');
      if (newWindow) {
        newWindow.close();
      }
      return;
    }

    const html = await response.text();

    if (newWindow) {
      newWindow.document.open();
      newWindow.document.write(html);
      newWindow.document.close(); // Required to render the page
    }

  } catch (error) {
    console.error('Error fetching help doc:', error);
  }
};


  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        height: '5vh',
        color: theme.palette.primary.main,
        marginLeft:'2.3vw',
        marginRight:'2.3vw',
        marginTop:'1vw'
      }}
    >
      {/* Left Side: Logo and Company Name */}
      <Box>
        <CustomBreadcrumbs />
      </Box>


      {/* Right Side: Menu Items */}
      <Box sx={{ display: 'flex', alignItems: 'center', color: theme.palette.text.secondary }}>
        <IconButton color="inherit" aria-label="Help" sx={{ px: '0.8vw',gap:'0.3vw' }} onClick={handleHelpClick}>
          <i className="fa-regular fa-circle-question fa-xs" />
          <Typography color="textSecondary" fontSize="1.6vh" fontWeight={600} >
            Help
          </Typography>
        </IconButton>
        {/* <IconButton color="inherit" aria-label="settings" sx={{p:'0.8vw',py:'1vw'}}>
          <i className="fa-solid fa-gear fa-xs" />
        </IconButton>
        <IconButton color="inherit" aria-label="notifications" sx={{p:'0.8vw',py:'1vw',mr:'0.5vw'}}>
          <i className="fa-regular fa-bell fa-xs"></i>
        </IconButton> */}

        <Box sx={{ position: 'relative' }}>

          <Box onClick={handleTogglePopup} sx={{ cursor: 'pointer' }}>
            {updatedImage ? (
              <AvatarImage 
                  imageData={updatedImage.replace(/^data:image\/\w+;base64,/, "")} 
                  Mimetype={updatedImage?.match(/^data:(image\/\w+);base64/)?.[1] || "image/jpeg"} 
                  height="38px" width="38px" />
            ) : userData?.UserNum ? (
              <AvatarImage imageData={userData.ImageData} Mimetype={userData.MIMEType} height="38px" width="38px" />
            ) : (
              <AccountCircleOutlinedIcon sx={{ fontSize: '38px' }} />
            )}
          </Box>

          {isPopupOpen && (
            <ProfileNavBarPopup
              name={userData?.UserName}
              email={userData?.EmailID}
              open={isPopupOpen}
              onClose={handlePopupClose}
              onProfileEditClick={handleProfileEditToggle} // Pass the handler here
              handleLogout={handleLogout}
            />
          )}
        </Box>
      </Box>

      {/* Conditionally Render ProfileEditPanel */}
      {isProfileEditVisible && (
        <ProfileEditPanel
          onClose={handlePopupClose}
          userData={userData}
          updateUserData={updateUserData}
          setUpdatedImage={setUpdatedImage}
        /> // Pass the onClose prop properly
      )}
    </Box>
  );
};

export default TopNav;

